import { Modal, ModalContent } from "@nextui-org/react";

const ModelNext = ({ isOpen, onOpenChange, children }: any) => {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      className="flex items-center justify-center overflow-auto scrollbar-hide"
    >
      <ModalContent className="2xl:max-w-3xl xl:max-w-4xl sm:max-w-lg md:max-w-xl lg:max-w-2xl w-full h-fit xl:max-h-[60vh] lg:max-h-[56vh] max-h-[54vh] overflow-y-scroll no-scrollbar">
        {() => (
          <>
            <div className="lg:py-3 w-[100%]">{children}</div>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default ModelNext;
